module.exports = __webpack_public_path__ + "static/img/share-icon.1bb4cb93.svg";